import type { ViewModelEntity } from '@view-model/domain/view-model';
import { ViewModelItem } from '../ViewModelItem';
import type { Workspace } from '@workspace/domain/workspace/Workspace';
import { controlAtom } from '@user/Sidebar/SidebarContainer/SidebarTree/SidebarTreeStore/sidebarTreeControlState';
import { useAtomValue } from 'jotai';

type Props = {
  showEditMenu: boolean;
  viewModels: ViewModelEntity[];
  workspace: Workspace;
  showConfigureIndividualPermissions: boolean;
};

export const ViewModelList: React.FC<Props> = ({
  showEditMenu,
  viewModels,
  workspace,
  showConfigureIndividualPermissions,
}: Props) => {
  const { scrolledViewModelId } = useAtomValue(controlAtom);

  return (
    <div className="p-2">
      {viewModels.map((viewModel) => (
        <ViewModelItem
          key={viewModel.id}
          viewModel={viewModel}
          showEditMenu={showEditMenu}
          workspace={workspace}
          showConfigureIndividualPermissions={showConfigureIndividualPermissions}
          shouldBeScrolled={scrolledViewModelId === viewModel.id}
        />
      ))}
    </div>
  );
};
